
// Page navigation registry - centralized link management to prevent broken links
//
// Usage in components:
//   import { pageLinks } from '../pageLinks'
//   <Link to={pageLinks.Login()}>Login</Link>
//   navigate(pageLinks.PollVotingForm(id))
//
// Key naming convention: Keys MUST match the page TSX file name (without .tsx extension)
// e.g., Login.tsx -> pageLinks.Login(), PollList.tsx -> pageLinks.PollList()

import { authPageLinks } from './auth'

// global_shortcut_xxx are not Pages
// one of the pageLink must be /, otherwise global_shortcut_home will be a broken link
export const pageLinks = {
  Home: () => '/',
  Dashboard: () => '/dashboard',
  LabelGenerator: (id: string) => `/label/${id}`,

  // A+ Content Tracker
  AplusDashboard: () => '/aplus',
  AplusListings: () => '/aplus/listings',
  AplusAddListing: () => '/aplus/listings/add',
  AplusListingDetail: (id: string) => `/aplus/listings/${id}`,

  // Amazon Seller
  AmazonListings: () => '/amazon/listings',
  AmazonOrders: () => '/amazon/orders',

  // CoPilot
  CoPilot: () => '/copilot',

  // Auth pages
  ...authPageLinks,

  global_shortcut_home: () => '/', // MUST BE '/', do not change
  global_shortcut_login: (): string => authPageLinks.Login(),
  global_shortcut_register: (): string => authPageLinks.Register(),
  global_shortcut_verify_email: (): string => authPageLinks.VerifyEmail(),
  global_shortcut_request_password_reset: (): string => authPageLinks.RequestPasswordReset(),
  global_shortcut_reset_password: (): string => authPageLinks.ResetPassword(),
}


export function getPageLinkFullUrl<K extends keyof typeof pageLinks>(
  pageName: K,
  ...args: Parameters<(typeof pageLinks)[K]>
): string {
  const linkFn = pageLinks[pageName] as (...args: unknown[]) => string
  const path = linkFn(...args)
  return `${window.location.origin}${path}`
}
